import { render } from "./NewPackNotice.vue?vue&type=template&id=21afce7a"
import script from "./NewPackNotice.vue?vue&type=script&lang=js"
export * from "./NewPackNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__